import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { GlobalService } from '../../_services/global.service';
import { DatasearchService } from '../../_services/datasearch.service';
import { Router, RouterLink } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgFor,
    NgIf,
    NgStyle,
    NgClass,
    RouterLink,
    NgxSpinnerModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  @ViewChild('aboutVideo') aboutVideo!: ElementRef;
  @ViewChild('IntroVideo') IntroVideo: any;
  @ViewChild('introVideoHome') introVideoHome!: ElementRef;

  clients: any = [];
  platforms: any = [];
  services: any = [];
  testimonials: any = [];
  transparent = true;
  isVisible = false;

  platformLogoUrl = 'https://www.chemrobotics.com/assets/images/megamenu-icon/';
  clientLogoUrl = 'https://adminbackend.chemrobotics.com/uploads/clients/';
  introVideo =
    'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-Agrochemical-Pharmaceutical-Fine-Chemical-Database-Patents.mp4';
  aboutIntoVideo =
    'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4';
  aboutThumbnail =
    'https://www.chemrobotics.com/assets/images/banner/about-banner.png';
  wedoThumbnail = '../../../assets/img/what_we_do.webp';
  serviceLogoUrl = '../../../assets/icons/';
  aboutbaseurl='https://adminbackend.chemrobotics.com/uploads/about-us/'
  aboutusdata:any =[];
  constructor(
    private globalservice: GlobalService,
    private datasearch_service: DatasearchService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getClients();
    this.getPlatforms();
    this.getAboutUs();
    this.getServices();
    this.getTestimonials();
  }

  //----------- This API load all clients and so we change API to get top 5 clients for "Home page"------------//
  // getClients(){
  //   this.datasearch_service.getClients().subscribe(res => {
  //     this.clients = res.data;
  //   });
  // }

  getClients() {
    this.datasearch_service.getClients_home().subscribe((res: any) => {
      this.clients = (res.data || [])
        .filter((client: any) => client.isActive === true)
        .sort((a: any, b: any) => (a.priority || 0) - (b.priority || 0));
    });
  }

  getPlatforms() {
    this.platforms = [
      {
        platform: 'AgroPat Ultimate Discovery Suite',
        shortName: 'APD',
        logo: 'menu-icon1-1.png',
        link: 'https://www.chemrobotics.com/agropat-ultimate/',
      },
      {
        platform: 'AgroPat Ultimate Generic Suite',
        shortName: 'APG',
        logo: 'menu-icon2-2.png',
        link: 'https://www.chemrobotics.com/agro-suite/agropat-ultimate-2',
      },
      {
        platform: 'Technical Route',
        shortName: 'TechR',
        logo: 'menu-icon111.png',
        link: 'https://www.chemrobotics.com/agro-suite/technical-routes',
      },
      {
        platform: 'ChemiTracker - A Supplier Guide',
        shortName: 'CT',
        logo: 'menu-icon12.png',
        link: 'https://www.chemitracker.chemrobotics.com/',
      },
      {
        platform: 'Global MRL Database',
        shortName: 'MRL',
        logo: 'menu-icon33.png',
        link: 'https://www.chemrobotics.com/agro-suite/mrl-database',
      },
      {
        platform: 'QuikPatent - Constraining Patent Guide',
        shortName: 'QP',
        logo: 'menu-icon10.png',
        link: 'https://quikpatent.chemrobotics.com/',
      },
      {
        platform: 'Indian Pesticide Database ',
        shortName: 'IPD',
        logo: 'menu-icon7.png',
        link: 'https://ipd.chemrobotics.com/#/',
      },
      {
        platform: 'Global Agro Product Directory ',
        shortName: 'GAPD',
        logo: 'menu-icon8.png',
        link: 'https://www.chemrobotics.com/agro-suite/global-agro-product-directory',
      },
      {
        platform: 'Active Patents',
        shortName: 'AP',
        logo: 'menu-icon14.png',
        link: 'http://activepatents.chemrobotics.com/',
      },
      {
        platform: 'PharmVetPat Ultimate',
        shortName: 'PharmVetPat',
        logo: 'PharmaVatPat.jpg',
        link: 'https://chemroboticspharma.com/pharmVetPat',
      },
      {
        platform: 'AgroPharm XIM DB Beta',
        shortName: 'XIM',
        logo: 'menu-icon17.png',
        link: 'https://agropharmexim.chemrobotics.com/#/agropharm-xim-beta',
      },
      {
        platform: 'Supplementary Protection Certificate ',
        shortName: 'SPC',
        logo: 'menu-icon-SPC.jpeg',
        link: 'https://www.chemrobotics.com/agropharm/#/spcdb',
      },
    ];
  }

  getAboutUs() {
    this.datasearch_service.getAboutus().subscribe(res => {
      this.aboutusdata = res.data;
      console.log("about us data",this.aboutusdata)
    });
  }

  toggleVideo() {
    const video: HTMLVideoElement = this.aboutVideo.nativeElement;
    if (!video.paused || video.ended) {
      video.pause();
    } else if (video.readyState >= 2) {
      video.play().catch(error => console.error("Play error:", error));
    } else {
      console.warn("Video not ready yet.");
    }
  }
  toggleintroVideo() {
    const video: HTMLVideoElement = this.IntroVideo.nativeElement;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  toggleIntroVideoHome() {
    const video: HTMLVideoElement = this.introVideoHome.nativeElement;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
  closeIntroVideoHome() {
    const video: HTMLVideoElement = this.introVideoHome.nativeElement;
    video.pause();
  }
  getServices() {
    this.services.push({
      name: 'BuyActiveIngredient.com',
      description:
        'Buy & Sell platform for Agrochemicals, Active Pharmaceutical Ingredient and their intermediates, etc.',
      logo: 'buy.png',
    });
    this.services.push({
      name: 'Product Development Support',
      description:
        'Unique Customer Team Program to ensure that we deliver exemplary service at every level',
      logo: 'support.png',
    });
    this.services.push({
      name: 'Customer – Focused Services',
      description:
        'Unique Customer Team Program to ensure that we deliver exemplary service at every level',
      logo: 'customer.png',
    });
    this.services.push({
      name: 'IP Services',
      description:
        'We advise on IP right to protect aspects of : patent, copyright, trademark, industrial design etc.',
      logo: 'ipservices.png',
    });
    this.services.push({
      name: 'Patent',
      description:
        'Provide services in drafting, filing of application and describe how to implement and use the invention.',
      logo: 'patent.png',
    });
    this.services.push({
      name: 'Intellectual property solutions',
      description:
        'Enables business to increase revenue , optimize operations and manage IP.',
      logo: 'intellectualproperty.png',
    });
  }

  getTestimonials() {
    this.testimonials.push({
      description:
        'We have been waiting on this product and now that we have installed a few. We think it will make the industry by storm.',
      given_by: 'Ryan Oliver',
      designation: 'Design Manager at Kiluna',
      image: '../../../assets/img/testimages/Photo1.png',
    });
    this.testimonials.push({
      description:
        'Thank you for introducing me to Cham Robotics! e like how the system gives updates to us and the homeowner as well to give us a real-time update on how everything is working.',
      given_by: 'Gladina Samantha',
      designation: 'CEO Jobdesk United, LLC',
      image: '../../../assets/img/testimages/Photo2.png',
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isVisible = window.pageYOffset > 70;
    this.transparent = !this.isVisible;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  demoRequest() {
    this.scrollToTop();

    this.router.navigate(['/demo_request']);
  }
}
